export const _en = {
    rulesCategory: {
        layer: {
            libelle: "Rule category"
        },
        buttons: {
            add: {
                label: "Add a rule category"
            },
            del: {
                label: "Delete a rule category"
            }
        },
        dialog: {
            creation: {
                title: "Add a new rule category"
            },
            edition: {
                title: "Add a new rule category"
            },
            deletion: {
                title: "Delete a rule category"
            }
        },
        deletedCheckBox: {
            label: "Display deleted data"
        }
    }
};

export const _fr = {
    rulesCategory: {
        layer: {
            libelle: "Catégories de règle"
        },
        buttons: {
            add: {
                label: "Catégorie de règle"
            },
            del: {
                label: "Supprimer une catégorie de règle"
            }
        },
        modal: {
            creation: {
                title: "Ajout d'une nouvelle catégorie de règle"
            },
            edition: {
                title: "Édition d'une catégorie de règle"
            },
            deletion: {
                title: "Supprimer une catégorie de règle"
            }
        },
        deletedCheckBox: {
            label: "Afficher les catégories de règles archivées"
        }
    }
};